import { render, staticRenderFns } from "./ZoomSlider.vue?vue&type=template&id=1042c458&scoped=true&"
import script from "./ZoomSlider.vue?vue&type=script&lang=js&"
export * from "./ZoomSlider.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSlider.vue?vue&type=style&index=0&id=1042c458&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042c458",
  null
  
)

export default component.exports